export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";